import { render, staticRenderFns } from "./FooterSecondary.vue?vue&type=template&id=10d1888a&"
import script from "./FooterSecondary.vue?vue&type=script&lang=js&"
export * from "./FooterSecondary.vue?vue&type=script&lang=js&"
import style0 from "./FooterSecondary.vue?vue&type=style&index=0&id=10d1888a&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports